import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { updateUserConfigurationService } from 'owa-session-store/lib/services/updateUserConfigurationService';
import { CALENDAR_SELECTION_END } from 'mini-calendar-utils/lib/eventSignalConstants';

const VIEW_STATE_CONFIGURATION = 'OWA.ViewStateConfiguration';
const UPDATE_SELECTED_CALENDARS_VIEW_STATE_DELAY_MS = 2 * 100;

let updateSelectedCalendarsViewStateTimer: any = null;
let selectedCalendarsViewState: string[];

let ctxs = [];

/**
 * Utility to trigger service call to update userConfiguration with the selected calendars.
 */
export function updateSelectedCalendars(userConfiguration: OwaUserConfiguration) {
    if (
        userConfiguration &&
        userConfiguration.ViewStateConfiguration &&
        userConfiguration.ViewStateConfiguration.SelectedCalendarsTNarrow
    ) {
        selectedCalendarsViewState =
            userConfiguration.ViewStateConfiguration.SelectedCalendarsTNarrow;
        // Save this changes with a timer so we can batch all of them together.
        if (!updateSelectedCalendarsViewStateTimer) {
            updateSelectedCalendarsViewStateTimer = setTimeout(function () {
                // Clear the time handle.
                updateSelectedCalendarsViewStateTimer = null;

                // Make the call.
                updateUserConfigurationService(
                    [
                        {
                            key: 'SelectedCalendarsTNarrow',
                            valuetype: 'StringArray',
                            value: selectedCalendarsViewState,
                        },
                    ],
                    VIEW_STATE_CONFIGURATION
                )
                    .then(response => {
                        endCtxs();
                    })
                    .catch(endCtxs);
            }, UPDATE_SELECTED_CALENDARS_VIEW_STATE_DELAY_MS);
        }
    }
}

export function persistCtx(ctx: any) {
    ctxs.push(ctx);
}

function endCtxs(error?: Error) {
    ctxs.map(ctx =>
        ctx?.signal(
            CALENDAR_SELECTION_END,
            undefined /**inputPayload */,
            undefined /** actionSource */,
            error && { error }
        )
    );
    ctxs = [];
}
